var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFunctionalityTrashSmall = function SvgFunctionalityTrashSmall(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#242E30",
    clipPath: "url(#functionalityTrashSmall_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.864 1.219H6.136L5.49 2.53h5.022zM1.875 3.844v1.312h.962l.788 8.243a1.53 1.53 0 0 0 1.523 1.382h5.722a1.53 1.53 0 0 0 1.505-1.382l.779-8.243h.971V3.844zm9.205 9.406a.23.23 0 0 1-.219.201H5.14a.23.23 0 0 1-.219-.201l-.77-8.094h7.7z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "functionalityTrashSmall_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 1h14v14H1z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFunctionalityTrashSmall);
export default ForwardRef;